import { imageBaseUrl, avatarBaseUrl, bucketName } from '../config';
import _ from 'lodash';

/*
const fileSizes = [ Types
  { size: 101, label: 'small_' },
  { size: 216, label: 'x_small_' },
  { size: 450, label: 'x_medium_' },
  { size: 1024, label: 'x_large_' },
];
*/

export const buildPhotoPath = (type, name) =>
  `https://${bucketName}${imageBaseUrl}/${type}_${name}`;

export const buildAvatarPath = (name, type) => {
  if (!name) {
    return 'https://www.yoodlize.com/images/user-solid.svg';
  }
  return `https://${bucketName}${avatarBaseUrl}/${
    type ? `${type}_` : 'medium_' + ''
  }${name}`;
};
export const buildDocumentPath = name => {
  return `https://${bucketName}${imageBaseUrl}/${name}`;
};

export const buildImageColumns = photosList => {
  if (!photosList) return {};

  const images = {};

  const sorted = _.sortBy(photosList, 'isCover');

  const images1 = sorted.map(img => buildPhotoPath('small', img.name));

  images.images1 = images1;
  images.cover =
    photosList.length > 0 ? buildPhotoPath('x_medium', sorted[0].name) : '';
  return images;
};



// WEBPACK FOOTER //
// ./src/helpers/photoutils.js